import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import type AssignedGroup from "../../../../../interfaces/assignedGroup";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "../../../../Application/slices/createFetchingItemsSlice";

export interface EventGroupsToAddState extends FetchingItemsState<AssignedGroup> {}

export const initialState: EventGroupsToAddState = {
  items: [],
  itemsCount: 0,
  isLoading: false,
  error: undefined,
};

const eventGroupsToAddSlice = createFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.Events,
    name: "groupsToAdd",
  },
  initialState,
  reducers: {},
});

export const { fetchBegin, fetchSuccess, fetchFailure, reset } = eventGroupsToAddSlice.actions;

export default eventGroupsToAddSlice.reducer;
export type eventGroupsToAddSliceStateType = ReturnType<typeof eventGroupsToAddSlice.reducer>;
